import type { Audience, Viewer } from './types';

/** true, wenn der Viewer zu einer der Zielgruppen gehört ('ALL' = jedes angemeldete Konto). */
export function matchesAudience(audience: readonly Audience[], viewer: Viewer): boolean {
  return audience.some((entry) => entry === 'ALL' || viewer.roles.has(entry));
}

/** Filtert nach `visible(viewer)` und sortiert nach `order`. */
export function visibleSorted<T extends { visible?: (viewer: Viewer) => boolean; order?: number }>(
  items: readonly T[],
  viewer: Viewer,
): T[] {
  return items
    .filter((item) => item.visible?.(viewer) ?? true)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
